import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

const pb23CarouselMain = {
    init: function () {
        console.log("pb23-carousel--main: INIT");
        // Toggle Submenus 
        $('.pb23-carousel--main .jsCarouselContent').each(
            function() 
            {
            var jsCarContent = new Splide(this, {
                type: 'fade',
                rewind: true,
                perPage: 1,
                perMove: 1,
                arrows: true,
                arrowPath: 'M7.5,9a1.5,1.5,0,0,1-1.061-.439l-7.5-7.5a1.5,1.5,0,0,1,0-2.121,1.5,1.5,0,0,1,2.121,0L7.5,5.379l6.439-6.439a1.5,1.5,0,0,1,2.121,0,1.5,1.5,0,0,1,0,2.121l-7.5,7.5A1.5,1.5,0,0,1,7.5,9Z',
                pagination: true,
                autoplay: true,
                interval: 5000,
                infinite: true
            });
            var imageCarousel = $(this).parents('.pb23-container').find('.jsCarouselImage');
            if (imageCarousel.length > 0)
            {
                var jsCarImage = new Splide(imageCarousel[0], {
                    type: 'loop',
                    arrows: false,
                    pagination: false,
                    gap: '1px'
                });
                jsCarContent.on( 'mounted', function () {
                    var contentLenght = jsCarContent.length;
                    if ( contentLenght <= 1 ) {
                        jsCarContent.options = {
                            rewind: false,
                            arrows: false,
                            pagination: false,
                            autoplay: false, 
                            infinite: false
                        };
                        
                    }
                } );
                jsCarContent.sync(jsCarImage);
                jsCarImage.on( 'mounted', function () {
                    var imageLenght = jsCarImage.length;
                    if ( imageLenght <= 1 ) {
                        jsCarImage.options = {
                            arrows: false,
                            pagination: false,
                        };
                    }
                });
            }
            jsCarContent.mount();
            if (imageCarousel.length > 0)
            {
                jsCarImage.mount();
            }
        });
    }
}


window.loadedComponents.push({ component: 'pb23-carousel--main', init: pb23CarouselMain.init});

export default() => {
    pb23CarouselMain.init();
}